// extracted by mini-css-extract-plugin
export default {"gradientButton":"Kih1_Hd3","disabledGradientButton":"jv_8gdtr","disabledCover":"I3IHnbG4"};